import axios from "axios";

export default axios.create({
  baseURL: "https://64188b7a29e7e36438eb6466.mockapi.io",
});
